import { registerPlugin } from '@capacitor/core';

let CameraPluginInstance;

const getCameraPlugin = () => {
  if (!CameraPluginInstance) {
    CameraPluginInstance = registerPlugin('CameraPlugin');
  }
  return CameraPluginInstance;
};

export default getCameraPlugin;